import React from 'react';
import { useRiskPropertyContext } from './context';
import { FieldsBuilder } from '../../../../../../libs/uiKit/fieldsBuilder';

const RiskPropertyUi: React.FC = () => {
	const { form } = useRiskPropertyContext();

	return <FieldsBuilder {...form} />;
};

export default React.memo(RiskPropertyUi);
